import { render } from "./ProjectAnalysis.vue?vue&type=template&id=00771cf8"
import script from "./ProjectAnalysis.vue?vue&type=script&lang=js"
export * from "./ProjectAnalysis.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__